// Pre-game financial questionnaire. No sensitive/PII financial data is collected.
export const QUESTIONS = [
  {
    id: "confidence",
    question: "How confident are you managing your money?",
    type: "single",
    options: ["Not confident yet", "A little confident", "Fairly confident", "Very confident"],
  },
  {
    id: "emergency_fund",
    question: "Do you currently keep an emergency fund?",
    type: "single",
    options: [
      "No",
      "Yes, less than 1 month of expenses",
      "Yes, 1–3 months of expenses",
      "Yes, 3–6 months of expenses",
      "Yes, more than 6 months of expenses",
      "I'm not sure what an emergency fund is",
    ],
  },
  {
    id: "unexpected_expenses",
    question: "How do you usually manage unexpected expenses?",
    type: "single",
    options: [
      "Use money I already have available",
      "Use my emergency savings",
      "Use a credit card",
      "Borrow from family or friends",
      "Take out a loan",
      "I'm not sure",
    ],
  },
  {
    id: "investing_familiarity",
    question: "How familiar are you with investing?",
    type: "single",
    options: [
      "I've never invested",
      "I understand the basics but haven't started",
      "I invest occasionally",
      "I invest regularly",
    ],
  },
  {
    id: "priority",
    question: "What is your biggest financial priority right now?",
    type: "single",
    options: [
      "Managing everyday expenses",
      "Building an emergency fund",
      "Paying down debt",
      "Saving for a major purchase",
      "Buying a home",
      "Investing and building wealth",
      "Planning for retirement",
      "I'm not sure yet",
    ],
  },
];

// Build the list of {id, question, answer} to persist against the session.
export function buildResponses(answers) {
  return QUESTIONS.map((q) => {
    let answer = answers[q.id];
    if (q.type === "scale") {
      const opt = q.options.find((o) => o.value === answers[q.id]);
      answer = opt ? `${opt.value} — ${opt.label}` : "";
    }
    return { id: q.id, question: q.question, answer: answer || "" };
  });
}
